import { render, staticRenderFns } from "./external-accounts-main.vue?vue&type=template&id=0a2b977c&scoped=true"
import script from "./external-accounts-main.vue?vue&type=script&lang=js"
export * from "./external-accounts-main.vue?vue&type=script&lang=js"
import style0 from "./external-accounts-main.vue?vue&type=style&index=0&id=0a2b977c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b977c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2b977c')) {
      api.createRecord('0a2b977c', component.options)
    } else {
      api.reload('0a2b977c', component.options)
    }
    module.hot.accept("./external-accounts-main.vue?vue&type=template&id=0a2b977c&scoped=true", function () {
      api.rerender('0a2b977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin_settings/components/external-accounts/external-accounts-main.vue"
export default component.exports